import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const PreAuthorizedAPI = {
  /**
   * Obtiene pre-autorizados por ID
   * @param {string} token Token de autenticación
   * @param {number} id ID del pre-autorizado
   * @returns {Promise} Respuesta de la API
   */
  getPreAuthorizedById: async (token, id) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/pre-authorized/${id}`,
      headers: { Authorization: token },
    });
  },

  /**
   * Obtiene listado de pre-autorizados con filtros y paginación
   * @param {string} token Token de autenticación
   * @param {object} params Parámetros de búsqueda y paginación
   * @returns {Promise} Respuesta de la API
   */
  getPreAuthorized: async (token, params = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/pre-authorized`,
      headers: { Authorization: token },
      params,
    });
  },

  /**
   * Obtiene listado de pre-autorizados con filtros en una hoja de cálculo.
   * @param {string} token Token de autenticación
   * @param {object} params Parámetros de búsqueda
   * @returns {Promise} Respuesta de la API.
   */
  downloadPreAuthorized: async (token, params = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/pre-authorized/report/download`,
      headers: { Authorization: token },
      params,
      responseType: "blob",
    });
  },

  /**
   * Crea un nuevo pre-autorizado
   * @param {string} token Token de autenticación
   * @param {object} data Datos del pre-autorizado
   * @returns {Promise} Respuesta de la API
   */
  createPreAuthorized: async (token, data) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/pre-authorized`,
      headers: { Authorization: token },
      data,
    });
  },

  /**
   * Actualiza un pre-autorizado existente
   * @param {string} token Token de autenticación
   * @param {object} data Datos del pre-autorizado
   * @returns {Promise} Respuesta de la API
   */
  updatePreAuthorized: async (token, data) => {
    return await axios({
      method: "PUT",
      url: `${BACKEND_ORIGIN}/api/pre-authorized`,
      headers: { Authorization: token },
      data,
    });
  },

  /**
   * Elimina un pre-autorizado por su ID
   * @param {string} token Token de autenticación
   * @param {number} id ID del pre-autorizado
   * @returns {Promise} Respuesta de la API
   */
  deletePreAuthorized: async (token, id) => {
    return await axios({
      method: "DELETE",
      url: `${BACKEND_ORIGIN}/api/pre-authorized/${id}`,
      headers: { Authorization: token },
    });
  },
};

export default PreAuthorizedAPI;
